import React from "react";
import Button from "../TabletButton";
import { useTheme } from "@material-ui/core/styles";

const getBusyStyles = (theme, variant, color) => {
	const buttonTokens = theme?.neoUI?.buttons?.action || {};

	if (variant === "outlined") {
		return color === "secondary"
			? buttonTokens.busyCancel || {}
			: buttonTokens.busyOutline || {};
	}

	if (color === "secondary") {
		return buttonTokens.busyError || buttonTokens.busy || {};
	}

	if (color === "inherit") {
		return buttonTokens.busyOutline || buttonTokens.busy || {};
	}

	return buttonTokens.busy || {};
};

const ButtonWithSpinner = ({ loading, children, disabled, style, variant = "text", color = "default", ...rest }) => {
	const theme = useTheme();
	const busyStyles = loading
		? getBusyStyles(theme, variant, color)
		: null;

	return (
		<Button
			disabled={loading || disabled}
			variant={variant}
			color={color}
			style={{
				...style,
				...(busyStyles || {}),
				...(loading
					? {
						WebkitTextFillColor: busyStyles?.color,
					}
					: {}),
			}}
			aria-busy={loading || undefined}
			data-loading-state={loading ? "busy" : "idle"}
			{...rest}
		>
			{children}
		</Button>
	);
};

export default ButtonWithSpinner;
